<template>
  <div>
    <div
      class="order"
      :class="{
        'fixed-order': orderFixed && breakpoint.mdAndDown,
        'has-cookie': showCookie
      }"
    >
      <div class="moblie-cart-tab">
        <div
          :class="deliveryType == 0 ? 'delivery_type active' : 'delivery_type'"
          v-show="storeInfo.takeawayStatus == 1"
          @click="changeDeliveryType(0)"
        >
          <v-icon
            center
            color="#1867c0"
            v-if="deliveryType == 0"
            style="margin-right: 5px"
            >done
          </v-icon>
          {{ $t("delivery.home_delivery") }}
        </div>
        <div
          :class="deliveryType == 1 ? 'delivery_type active' : 'delivery_type'"
          @click="changeDeliveryType(1)"
          :style="storeInfo.takeawayStatus != 1 ? 'width: 50%' : ''"
        >
          <v-icon
            center
            color="#1867c0"
            v-if="deliveryType == 1"
            style="margin-right: 5px"
            >done
          </v-icon>
          {{ $t("delivery.pick_up") }}
        </div>
        <!--        <div-->
        <!--          class="delivery_type"-->
        <!--          @click="isShowCart = !isShowCart"-->
        <!--          :style="storeInfo.takeawayStatus != 1 ? 'width: 50%' : ''"-->
        <!--        >-->
        <!--          <div class="shoppingcart-icon">-->
        <!--            <img class="icon" src="../../../assets/shopping-cart-avtive.png" />-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div v-show="breakpoint.mdAndDown ? true : isShowCart">
        <!-- 配送起送规则 -->
        <!--        <div class="minimum_amount" v-if="deliveryType == 0">-->
        <!--          {{ $t("delivery.minimum_amount") }}-->
        <!--          {{ storeInfo && storeInfo.takeawayMinimumConsumption }} €-->
        <!--        </div>-->

        <!--        <div class="minimum_amount" v-if="deliveryType == 0">-->
        <!--          {{ $t("delivery.minimum_amount") }}-->
        <!--          {{ storeInfo && storeInfo.takeawayMinimumConsumption }} €-->
        <!--        </div>-->
        <div
          class="new_price_box"
          v-if="storeInfo.deliveryType == 1 && deliveryType == 0"
        >
          <div class="left">
            Pedido mínimo<span>{{ storeDeliveryArea.startingPrice }}</span
            >€
          </div>
          <div class="right" v-if="storeDeliveryArea.deliveryPrice != '0.00'">
            Envío <span>{{ storeDeliveryArea.deliveryPrice }}</span
            >€
          </div>
          <div class="right" v-if="storeDeliveryArea.deliveryPrice == '0.00'">
            <span>Envío Gratis</span>
          </div>
          <div
            class="left"
            v-if="String(storeDeliveryArea.freePrice) != '0.00'"
          >
            Pedido superior a <span>{{ storeDeliveryArea.freePrice }}</span
            >€
          </div>
          <div
            class="right"
            v-if="String(storeDeliveryArea.freePrice) != '0.00'"
          >
            Envío Gratis
          </div>
          <img
            class="gth"
            @click="imgbtn()"
            src="../../../assets/new_gth.png"
            alt=""
            v-show="storeInfo.deliveryType == 1"
          />
        </div>
        <div style="clear: both"></div>
        <!--        第一二种配送方式的起送价-->
        <div
          class="minimum_amount"
          v-if="deliveryType == 0 && storeInfo.deliveryType != 1"
        >
          {{ $t("delivery.minimum_amount") }}
          {{ storeInfo.takeawayMinimumConsumption }} €
        </div>
        <!-- 自取起订费 -->

        <div class="minimum_amount" v-if="deliveryType == 1">
          {{ $t("delivery.minimum_amount") }}
          {{ storeInfo && storeInfo.takeMinAmount }} €
        </div>

        <div class="order-container">
          <div class="menu-heading">
            <h4>
              {{ $t("delivery.order_title") }}
            </h4>
          </div>
          <template v-if="cart.items.length > 0">
            <div class="order-list">
              <div
                class="order-item"
                v-for="(item, index) in cart.items"
                :key="index"
              >
                <v-layout class="order-list__item" align-center>
                  <v-flex
                    class="num"
                    shrink
                    xs2
                    @click="handleRemoveFromCart(item.guid, index)"
                  >
                    <v-layout align-center justify-center>
                      <span class="show-close">×</span>
                      <span class="show-num" :key="item.guid + item.num"
                        >{{ item.num }}×</span
                      >
                    </v-layout>
                  </v-flex>
                  <v-flex class="item-name" xs8>
                    <router-link
                      class="item-name__link"
                      :to="{
                        name: 'delivery/detail',
                        params: { id: item.delivery.guid }
                      }"
                    >
                      <!--                      <img-->
                      <!--                        class="cover"-->
                      <!--                        :src="item.delivery.cover.url"-->
                      <!--                        alt=""-->
                      <!--                        v-show="item.delivery.cover.url"-->
                      <!--                      />-->
                      <!--                      <div-->
                      <!--                        v-show="!item.delivery.cover.url"-->
                      <!--                        class="cover"-->
                      <!--                      ></div>-->
                      <span>{{
                        (item.delivery &&
                          item.delivery.commodity_name_json &&
                          item.delivery.commodity_name_json[
                            getTranslateIndex
                          ]) ||
                          item.delivery.name
                      }}</span>
                    </router-link>
                  </v-flex>
                  <v-flex class="price" shrink xs2>
                    €{{ item.delivery.takeawayPrice | fixed(2, true) }}
                  </v-flex>
                </v-layout>

                <div class="unit-price">
                  <span
                    v-for="(attr_item, index) in item.delivery.attributes"
                    :key="index"
                  >
                    <span
                      v-if="attr_item.check"
                      style="padding-right: 6px; white-space: nowrap;"
                      >{{ attr_item.name }}
                      <span v-if="attr_item.price && Number(attr_item.price)"
                        >€ {{ attr_item.price }}</span
                      >
                    </span>
                  </span>
                </div>

                <div
                  class="garnish-container"
                  v-if="item.garnish_items && item.garnish_items.length != 0"
                >
                  <v-layout>
                    <v-flex offset-xs4>
                      <div
                        class="garnish-item"
                        v-for="(garnish_item,
                        garnish_index) in item.garnish_items"
                        :key="garnish_index"
                      >
                        <div class="name">
                          {{ garnish_item.commodity_name }}
                        </div>
                        <div class="split"></div>
                        <div class="price">€{{ garnish_item.price }}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="description_row">
                  <textarea
                    :placeholder="$t('delivery.description')"
                    @input="handleInputDescription($event, item, index)"
                    :value="item.remark"
                  />
                </div>

                <div class="change-num-container">
                  <v-icon
                    class="stepper"
                    dark
                    @click="$emit('handle-minus-fromcart', item.guid, index)"
                    >remove_circle_outline
                  </v-icon>
                  <v-icon
                    class="stepper"
                    dark
                    @click="$emit('handle-addto-cart', item, index, $event)"
                    >add_circle_outline
                  </v-icon>
                </div>
              </div>
            </div>
            <v-layout class="total discount" v-if="discountAmount != 0">
              <v-flex class="subtotal">{{ $t("delivery.discount") }}</v-flex>
              <v-flex class="price">
                €{{ discountAmount | fixed(2, true) }}
              </v-flex>
            </v-layout>
            <v-layout class="total" v-if="deliveryType == 0">
              <v-flex class="subtotal">Envío</v-flex>
              <v-flex class="price" style="font-size: 16px"
                >€{{ deliveryFee | fixed(2, true) }}
              </v-flex>
            </v-layout>
            <v-layout class="total">
              <v-flex class="subtotal">{{ $t("delivery.subtotal") }}</v-flex>
              <v-flex class="price"
                >€{{ actuallyPaidAmount | fixed(2, true) }}
              </v-flex>
            </v-layout>

            <div>
              <!-- 配送确认按钮 -->
              <div
                v-if="deliveryType == 0 && storeInfo.deliveryType != 1"
                class="button shadow proceed-button"
                :class="{
                  disabled:
                    parseFloat(storeInfo.takeawayMinimumConsumption) >
                    parseFloat(actuallyPaidAmount)
                }"
                @click="onProceedToCheckout"
              >
                {{ $t("delivery.proceedToCheckout") }}
              </div>
              <div
                v-if="deliveryType == 0 && storeInfo.deliveryType == 1"
                class="button shadow proceed-button"
                :class="{
                  disabled:
                    parseFloat(storeDeliveryArea.startingPrice) >
                    parseFloat(actuallyPaidAmount)
                }"
                @click="onProceedToCheckout"
              >
                {{ $t("delivery.proceedToCheckout") }}
              </div>

              <!-- 自取确认按钮 -->
              <div
                v-if="deliveryType == 1"
                class="button shadow proceed-button"
                :class="{
                  disabled:
                    parseFloat(storeInfo.takeMinAmount) >
                    parseFloat(actuallyPaidAmount)
                }"
                @click="onProceedToCheckout"
              >
                {{ $t("delivery.proceedToCheckout") }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty-cart">{{ $t("delivery.emptyCart") }}</div>
          </template>
        </div>
      </div>
    </div>

    <!-- begin 未在营业时间 -->
    <v-dialog v-model="isNotOpenError" vertical max-width="500px">
      <v-card color="primary">
        <v-card-title>
          <span>{{ $t("delivery.is_not_open_store") }}</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="isNotOpenError = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- end 未在营业时间 -->

    <!--    运费提示-->
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">
            Gastos de envío
            <img
              class="close"
              src="../../../assets/close.png"
              @click="dialog = false"
              alt=""
            />
          </div>
        </v-card-title>
        <v-card-actions>
          <div class="dialog_box">
            <table style="width: 100%;text-align: center">
              <tr>
                <th>Zona</th>
                <th>Pedido mínimo</th>
                <th>Envío</th>
                <th>Superior a</th>
                <th>Envío</th>
              </tr>
              <tr v-for="(item, index) in createReservaList" :key="index">
                <td>{{ item.zipCode }}</td>
                <td>{{ item.startingPrice }}</td>
                <td>{{ item.deliveryPrice }}</td>
                <td v-show="item.freePrice != '0.00'">{{ item.freePrice }}</td>
                <td v-show="item.freePrice != '0.00'">Gratis</td>
              </tr>
            </table>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    金额不够提示-->
    <v-dialog v-model="isPrice" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <div class="headline">
            Pedido mínimo：€ <span>{{ storeDeliveryArea.startingPrice }}</span>
            <img
              class="close"
              src="../../../assets/close.png"
              @click="isPrice = false"
              alt=""
            />
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { fixed } from "../../../utils";
import order from "@/api/order";
// import order from "@/api/order";
export default {
  computed: {
    ...mapGetters(["cart", "getTranslateIndex"]),
    ...mapState([
      "storeInfo",
      "carts",
      "deliveryType",
      "showCookie",
      "zipCode",
      "deliveryFee",
      "storeDeliveryArea",
      "isLogin"
    ]),
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },
  props: {
    orderFixed: {},
    discountAmount: {},
    actuallyPaidAmount: {},
    showCart: {
      type: Boolean,
      default: false
    }
  },

  filters: {
    fixed
  },

  data() {
    return {
      isNotOpenError: false,
      isShowCart: true,
      dialog: false,
      createReservaList: [],
      isPrice: false
      // storeDeliveryArea: []
    };
  },
  created() {
    // this.getNewPirceInfo();
  },
  watch: {
    showCart() {
      this.isShowCart = this.showCart;
    }
  },

  methods: {
    ...mapMutations([
      "setDeliveryType",
      "resetCart",
      "setZipCode",
      "setZipCodeypeType"
    ]),
    async getNewPirceInfo() {
      let payload = {
        storeGuid: this.storeInfo.guid
      };
      try {
        const {
          data: { isError, data }
        } = await order.storeDeliveryArea(payload);

        if (isError) {
          return;
        }
        // this.newPric = data[0];
        // this.store.commit("setStoreDeliveryArea", data);
        if (data.length > 0) {
          this.storeDeliveryArea = data[0];
        } else {
          this.storeDeliveryArea = data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleInputDescription(e, guid, index) {
      let carts = this.carts.slice(0);
      carts[index].remark = e.target.value;
      this.resetCart(carts);
    },

    // 切换配送/取餐
    changeDeliveryType(e) {
      console.log("切换配送", e);

      this.$emit("change-delivery-type", e);
    },
    onProceedToCheckout() {
      if (!this.storeInfo.isRegisterOrder && !this.isLogin) {
        this.$router.push({ name: "login" });
        return;
      }
      if (
        this.deliveryType == 0 &&
        this.storeInfo.deliveryType == 1 &&
        parseFloat(this.storeDeliveryArea.startingPrice) >
          parseFloat(this.actuallyPaidAmount)
      ) {
        return;
      }
      if (
        this.deliveryType == 0 &&
        this.storeInfo.deliveryType != 1 &&
        parseFloat(this.storeInfo.takeawayMinimumConsumption) >
          parseFloat(this.actuallyPaidAmount)
      ) {
        return;
      }
      if (
        this.deliveryType == 1 &&
        parseFloat(this.storeInfo.takeMinAmount) >
          parseFloat(this.actuallyPaidAmount)
      ) {
        return;
      }
      if (!this.storeInfo.open) {
        this.isNotOpenError = true;
        return;
      }

      if (this.storeInfo.takeawayStatus == 0) {
        this.isNotOpenError = true;
        return;
      }

      this.$router.push({ name: "checkout" });
    },
    async getStoreDeliveryArea() {
      // console.log('进入这里',this.zipCode)
      // let data = { storeGuid: this.storeInfo.guid,zipCode:'' };
      this.setZipCodeypeType(true);
      localStorage.setItem("zipCode", this.zipCode);
      this.setZipCode("");
      // let payload = {
      //   zipCode: '',
      //   storeGuid:  this.storeInfo.guid,
      // };
      try {
        const res = await order.getStoreDeliveryArea();
        this.createReservaList = res.data.data;
        this.setZipCodeypeType(false);
        this.setZipCode(localStorage.getItem("zipCode"));
      } catch (e) {
        console.log(e);
      }
    },
    imgbtn() {
      this.getStoreDeliveryArea();
      this.dialog = true;
    }
  }
};
</script>

<style scoped lang="sass" src="../delivery-list.sass"></style>
<style scoped lang="sass">
.new_price_box
    width: 100%
    padding: 12px
    margin-top: 20px
    line-height: 30px

.new_price_box .left
    width: 68%
    float: left

.new_price_box .right
    width: 32%
    float: left

.new_price_box div span
    margin-left: 4px
    margin-right: 4px
    font-weight: bold
    font-size: 16px

.gth
    width: 20px
    float: right
    margin-top: -40px
    cursor: pointer

.headline
    text-align: center
    width: 100%

.dialog_box
    width: 100%
    min-height: 200px

.close
    width: 30px
    float: right
    cursor: pointer

.v-dialog
//min-height: 600px
</style>
